export class VeiculoModel {
    codveiculo : string;
    placa : string;
    modelo : string;
    modeloDms : string;
    marca : string;
    anomodelo : string;
    ano : string;
    ano2 : string;
    anofabmod : string;
    cor : string;
    codcliente : string;
    cliente : string;
    cpfcpnpj : string;
    email : string;
    endereco : string;
    endcomp : string;
    endn : string;
    cidade : string;
    bairro : string;
    cep : string;
    numero : string;
    telefone : string;
    km : string;
    combustivel : number;
    urlchecklist : string;
    integrado : number;
    osaberta: string;
    obs: string;
    idagendamento: string;
    horaagendada: string;
    dataagendamento: string;

    transmissao: string;
    motor: string;
    fipe: string;
    tipocombustivel: string;
    dadosExtras: object;
    tipoAtendimento: number;
    obsDiagnostico: string;
    imagem: string;
}

export class VeiculoCampModel{
    chassi: string;
    chassi_inicial: string;
    marcamodelo: string;
    modelo: string;
    anofabricacao: string;
    anomodelo: string;
    cor: string;
    municipio: string;
    uf: string;
    combustivel: string;
    potencia: string;
    carroceria: string;
    cilindradas: string;
    marca: string;
    renavam: string;
    anocombustivel: string;
    real_marca: string;
    real_combustivel: string;
    real_tipodacarroceria: string;
    real_modelo: string;
    real_veiculo: string;
    real_versao: string;
    real_motor: string;
    real_tracao: string;
    real_transmissao: string;
    real_portas: string;
    real_codigo_fipe: string;
    placa: string;
    placa_formatada: string;
    fipe: string;
    dadosExtras: object;
    
}
export class VeiculoModelIpiranga {
    marca: {
        codigo: number;
        descricao: string;
      };
    modelo: {
        codigo: number;
        descricao: string
    };
    tipoVeiculo: {
        codigo: number;
        descricao: string
    };
    motor: {
        codigo: number;
        descricao: string;
    };
    chaveVeiculo: number;
    placa: string;
    tipoCombustivel: string;
    tipoCambio: string;
    tipoOdometro: string;
    anoFabricacao: number;
    anoModelo: number;
    nacionalidade: string;
    numeroChassi: string;
    renavam: string;
}



// WEBPACK FOOTER //
// ./src/app/models/VeiculoModel.ts